import React from 'react';
import { TipsMapType } from '../index';

export const statsTipsRegionHeaderText: TipsMapType = {
  en: "The label 'Unidentified' in the graphs below represents reviews that cannot distinguish region/country.",
  zh: '下图中的 Unidentified 文字代表无法区分地区/国家的评论',
};

export const statsKeywordHeaderText: TipsMapType = {
  en: 'The keywords of this system consist of original keywords and merged keywords. Merged keywords are representatives of original keywords that have the same meaning in all languages, and the mention statistics are the total of the mentions of all related original keywords, with duplicates removed. This page needs to show the keyword trend chart. To improve the chart calculation efficiency and quickly compute the mentions of keywords on each date, the chart uses original keywords for statistics. Unlike the word cloud on the performance page that uses merged keywords, therefore the mention statistics of the keywords here may be different.',
  zh: '舆情系统关键词分为原始关键词和合成关键词。合成关键词是所有语言中同义原始关键词的代表，声量统计是所有原始关键词声量的总和，并去除重复项。本页需要统计关键词趋势图，为提高图表计算效率，快速计算出关键词在各日期的声量，统一在图表中使用原始关键词进行统计。与首页的词云使用合成关键词的算法不同，因此本页关键词统计与首页词云统计有所不同。',
};

export const statsTopicPositiveText: TipsMapType = {
  en: (
    <>
      <b>Calculation method:</b> <br />
      <b>Positive topic:</b> After classifying all mentions by topic, calculate
      the mentions and sentiment score of each topic. Topics with an sentiment
      score higher than 3.5 are positive topics, which are shown in the diagrams
      below.
    </>
  ),
  zh: (
    <>
      <b>计算规则:</b> <br />
      <b>正面话题：</b>
      将所有声量按话题分类后，计算各个话题的声量及情感分。情感分高于 3.5
      的话题为正面话题，显示在下方数据图中。
    </>
  ),
};

export const statsTopicNegativeText: TipsMapType = {
  en: (
    <>
      <b>Calculation method:</b> <br />
      <b>Negative topic:</b>After classifying all mentions by topic, calculate
      the mentions and sentiment score of each topic. Topics with an sentiment
      score lower than 2.5 are negative topics, which are shown in the diagrams
      below.
    </>
  ),
  zh: (
    <>
      <b>计算规则:</b>
      <br />
      <b>负面话题：</b>
      将所有声量按话题分类后，计算各个话题的声量及情感分。情感分低于 2.5
      的话题为负面话题，显示在下方数据图中。
    </>
  ),
};

export const statsKeywordPositiveText: TipsMapType = {
  en: (
    <>
      <b>Calculation method:</b>
      <br />
      <b>Positive keywords:</b>After classifying all mentions by keywords,
      calculate the mentions and sentiment score of each keyword. Keywords with
      an sentiment score higher than 3.5 are positive keywords, which are shown
      in the diagrams below.
    </>
  ),
  zh: (
    <>
      <b>计算规则:</b>
      <br />
      <b>正面关键词：</b>
      将所有声量按关键词分类后，计算各个关键词的声量及情感分。情感分高于 3.5
      的关键词为正面关键词，显示在下方数据图中。
    </>
  ),
};

export const statsKeywordNegativeText: TipsMapType = {
  en: (
    <>
      <b>Calculation method:</b> <br />
      <b>Negative keywords:</b>After classifying all mentions by keywords,
      calculate the mentions and sentiment score of each keyword. Keywords with
      an sentiment score lower than 2.5 are negative keywords, which are shown
      in the diagrams below.
    </>
  ),
  zh: (
    <>
      <b>计算规则:</b> <br />
      <b>负面关键词：</b>
      将所有声量按关键词分类后，计算各个关键词的声量及情感分。情感分低于 2.5
      的关键词为负面关键词，显示在下方数据图中。
    </>
  ),
};

// export const statsKeywordEmergingText: TipsMapType = {
//   en: (
//     <>
//       <b>Calculation method:</b> <br />
//       <b>Emerging Keywords：</b>Keywords that appear in the last hour, but
//       haven't appeared in the last 3 or 5 days (Days of Game Store/ Monitoring
//       Keywords/ Monitor Accounts are different), as Emerging keywords . Here are
//       the top 20 Emerging Keywords in terms of Mentions, and topics aggregated
//       based on these keywords.
//     </>
//   ),
//   zh: (
//     <>
//       <b>计算规则:</b> <br />
//       <b>突发关键词:</b>
//       统计过去 1 个小时出现，但是过去 3 天或者 5
//       天没出现过的关键词（商店、监控关键词、监控官号来源的周期天数不同），作为游戏突发的关键词。此处展示前20个突发关键词，并根据这些关键词聚合成突发话题。
//     </>
//   ),
// };
